import React from 'react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings";
import './../../config/util';

class MemberReferrer extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
    }

    render() {
        let user_info = this.props.user_info;

        return (
            <div>
                <div className="row">
                    <label>{strings.signup_path} : {user_info.path}</label>
                </div>
            </div >
        )
    }
}

export default MemberReferrer;